<template>
  <div class="gps-list">
    <table class="table is-fullwidth is-striped" v-if="hasDogProfiles">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th>Name</th>
          <th>Owner</th>
          <th>Id</th>
          <th>Added At</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="dogProfile in dogProfiles" :key="dogProfile.id">
          <td>
            <span v-if="tagText(dogProfile)" class="tag" :class="tagClass(dogProfile)">{{
              tagText(dogProfile)
            }}</span>
          </td>
          <td>
            <button
              class="button is-text is-size-6 has-text-danger"
              @click="deleteDogProfile(dogProfile)"
            >
              Delete
            </button>
          </td>
          <td>
            {{ dogProfile.name }}
          </td>
          <td>
            <span v-if="owner(dogProfile)">
              {{ owner(dogProfile).firstName }} {{ owner(dogProfile).lastName }} (<span
                >{{ dogProfile.ownerUserId }}_LLUser</span
              >)
            </span>
            <span v-else>{{ dogProfile.ownerUserId }}_LLUser</span>
          </td>
          <td>{{ dogProfile.id }}_DogProfile</td>
          <td>{{ dogProfile.createdAt }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { LOAD_USERS_WITH_IDS, GET_USER_WITH_ID } from '@/modules/users/usersCacheStore.js'

export default {
  name: 'DogProfilesList',

  components: {},

  props: {
    user: {
      type: Object,
      required: true
    },
    dogProfiles: {
      type: Array,
      default: () => []
    },
    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  mounted() {
    this.loadOwners()
  },

  methods: {
    loadOwners() {
      const userIds = this.dogProfiles.map(gps => gps.ownerUserId)
      const loadUsersAction = `${this.usersCacheStorePath}/${LOAD_USERS_WITH_IDS}`
      this.$store.dispatch(loadUsersAction, { userIds })
    },

    owner(dogProfile) {
      const getUserWithIdPath = `${this.usersCacheStorePath}/${GET_USER_WITH_ID}`
      return this.$store.getters[getUserWithIdPath](dogProfile.ownerUserId)
    },

    isOwner(dogProfile) {
      if (!dogProfile) {
        return false
      }
      if (!this.user) {
        return false
      }

      return dogProfile.ownerUserId === this.user.id
    },

    isAdmin(dogProfile) {
      if (!dogProfile) {
        return false
      }
      if (!this.user) {
        return false
      }

      return dogProfile.dogHandlerUserIds && dogProfile.dogHandlerUserIds.includes(this.user.id)
    },

    tagText(dogProfile) {
      if (this.isOwner(dogProfile)) {
        return 'Owner'
      }
      if (this.isAdmin(dogProfile)) {
        return 'Admin'
      }

      return null
    },

    tagClass(dogProfile) {
      return {
        'is-success': this.isOwner(dogProfile)
      }
    },

    deleteDogProfile(dogProfile) {
      this.$emit('delete-dog-profile', dogProfile)
    }
  },

  computed: {
    hasDogProfiles() {
      if (!this.dogProfiles) {
        return false
      }

      return this.dogProfiles.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.tag {
  width: 100%;
}

.table td {
  border-bottom: 0;
}

td span {
  white-space: nowrap;
}

td .button {
  padding: 0px;
  height: 1.5em;
}
</style>
